(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["skin-concern-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('concern-finder')) {
    class ConcernFinder extends HTMLElement {
      connectedCallback() {
        this.chips = Array.from(this.querySelectorAll('.cf__chip'));
        this.cards = Array.from(this.querySelectorAll('.cf__card'));
        this.status = this.querySelector('[data-cf-status]');
        this.scroller = this.querySelector('[data-cf-scroller]');
        this.bar = this.querySelector('.cf__bar');
        this.thumb = this.querySelector('[data-cf-thumb]');
        this.chipScroll = this.querySelector('.cf__chips-scroll');

        this.chips.forEach((chip) => {
          chip.addEventListener('click', () => this.select(chip.dataset.concern));
        });

        this.updateBar = this.updateBar.bind(this);
        this.updateChipFade = this.updateChipFade.bind(this);
        if (this.scroller) {
          this.scroller.addEventListener('scroll', this.updateBar, { passive: true });
        }
        if (this.chipScroll) {
          this.chipScroll.addEventListener('scroll', this.updateChipFade, { passive: true });
        }
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => { this.updateBar(); this.updateChipFade(); });
          this.ro.observe(this);
        } else {
          window.addEventListener('resize', this.updateBar);
        }

        // Optional deep link: ?concern=oil
        const param = new URLSearchParams(window.location.search).get('concern');
        if (param && this.chips.some((c) => c.dataset.concern === param)) {
          this.select(param);
        }
        requestAnimationFrame(() => { this.updateBar(); this.updateChipFade(); });
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        window.removeEventListener('resize', this.updateBar);
      }

      updateBar() {
        if (!this.scroller || !this.bar || !this.thumb) return;
        const { scrollWidth, clientWidth, scrollLeft } = this.scroller;
        const scrollable = scrollWidth - clientWidth > 2;
        this.bar.hidden = !scrollable;
        if (!scrollable) return;
        const trackW = this.bar.clientWidth;
        const thumbW = Math.max(trackW * (clientWidth / scrollWidth), 32);
        const progress = scrollLeft / (scrollWidth - clientWidth);
        this.thumb.style.width = thumbW + 'px';
        this.thumb.style.transform = 'translateX(' + (progress * (trackW - thumbW)) + 'px)';
      }

      updateChipFade() {
        if (!this.chipScroll) return;
        const el = this.chipScroll;
        const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 4;
        el.classList.toggle('is-end', atEnd);
      }

      select(concern) {
        this.chips.forEach((chip) => {
          chip.setAttribute('aria-pressed', String(chip.dataset.concern === concern));
        });

        let matches = 0;
        this.cards.forEach((card) => {
          const tags = (card.dataset.concerns || '').split(' ').filter(Boolean);
          const hit = concern === 'all' || tags.includes(concern);
          if (hit) matches++;
          card.classList.toggle('is-match', hit && concern !== 'all');
          card.classList.toggle('is-dimmed', !hit);
        });

        // Bring the matches into view on mobile
        if (this.scroller) {
          this.scroller.scrollTo({ left: 0, behavior: 'smooth' });
          requestAnimationFrame(this.updateBar);
        }

        if (this.status) {
          const chip = this.chips.find((c) => c.dataset.concern === concern);
          const label = chip ? chip.textContent.trim().toLowerCase() : '';
          let text;
          if (concern === 'all') {
            text = this.dataset.textAll;
          } else if (matches === 1) {
            text = this.dataset.textOne;
          } else {
            text = this.dataset.textMany;
          }
          this.status.textContent = text
            .replace('[count]', concern === 'all' ? this.dataset.total : matches)
            .replace('[concern]', label);
        }
      }
    }
    customElements.define('concern-finder', ConcernFinder);
  }

  } catch(e) { console.error(e); }
})();
})();
